export function isExpired(expiredDate) {
    const now = new Date().getTime();
    const expiredTime = new Date(expiredDate).getTime();
    return now >= expiredTime;
}

export function isAboutToBeExpired(expiredDate) {
    const now = new Date().getTime();
    const expiredTime = new Date(expiredDate).getTime();
    return now < expiredTime;
}